<template>
  <div class="product-list-component"
       :class="[
         `product-list--${type}`
       ]"
  >
    <template v-if="list.length > 0"
    >
      <item v-for="(item, index) in list"
            :key="index"
            :item="item"
            :lazy="lazy"
            :record-type="recordType"
            :block-title="blockTitle"
            :show-price="showPrice"
            :custom-collection-type="customCollectionType"
      />
    </template>
    <empty-page v-else-if="showEmpty"
                :hint="emptyString"
                :model="emptyModel"
    />
  </div>
</template>

<script>
  import Item from '@/components/ProductList/Item';
  import EmptyPage from '@/components/EmptyPage';

  export default {
    name: 'ProductList',
    components: {
      Item,
      EmptyPage,
    },
    props: {
      type: {
        type: String,
        default: 'page',
        validator(val) {
          return [
            'block',
            'page',
          ].includes(val);
        },
      },
      list: {
        type: Array,
        required: true,
      },
      showEmpty: {
        type: Boolean,
        default: false,
      },
      emptyString: {
        type: String,
        default: '暂无数据',
      },
      emptyModel: {
        type: String,
        default: 'page',
      },
      lazy: {
        type: Boolean,
        default: true,
      },
      recordType: {
        type: String,
        validator(val) {
          return [
            'main',
            'audio',
            'course',
            'courseNew',
            'parent',
            'learning',
            'studentGains',
            'customCollection',
          ].includes(val);
        },
      },
      blockTitle: {
        type: String,
        default: '',
      },
      showPrice: {
        type: Boolean,
        default: true,
      },
      customCollectionType: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-list {
    &-component {
      padding: 0 0 @size-base;
    }

    &--page {
      padding-top: @size-base;
    }
  }
</style>
